import { render, staticRenderFns } from "./TiiaEdit.vue?vue&type=template&id=b5020de6&scoped=true&lang=pug&"
import script from "./TiiaEdit.vue?vue&type=script&lang=js&"
export * from "./TiiaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5020de6",
  null
  
)

export default component.exports